import { Operators, Type as FilterType } from "../../../../fetch-xml/filter";
import { Record } from "../../Record/Record";
import { DataType } from "../../../../metadata";
import { TextCondition } from "./TextFiltering";
import { NumberCondition } from "./NumberCondition";
import { DateCondition } from "./DateCondition";
import { OptionSetCondition } from "./OptionSetCondition";
import { MultiSelectOptionSetCondition } from "./MultiSelectOptionSetCondition";
import { LookupCondition } from "./LookupCondition";
import { IDataProvider } from "../../interfaces";

export class RecordFilter {
    private _record: Record;
    private _dataProvider: IDataProvider;
    constructor(record: Record, dataProvider: IDataProvider) {
        this._record = record;
        this._dataProvider = dataProvider;
    }
    public validateConditions(type: ComponentFramework.PropertyHelper.DataSetApi.Types.FilterOperator, conditions: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression[]) {
        let result = true;
        for (let condition of conditions) {
            condition = this._conditionDecorator(condition);
            const attributeName = condition.attributeName;
            const dataType = this._dataProvider.getColumns().find(x => x.name === attributeName)?.dataType as DataType;
            switch (dataType) {
                case 'SingleLine.Text':
                case 'SingleLine.Email':
                case 'SingleLine.Phone':
                case 'SingleLine.TextArea':
                case 'Multiple':
                case 'SingleLine.URL': {
                    result = new TextCondition().isValid(this._record.getValue(attributeName) as string | null, condition);
                    break;
                }
                case 'Currency':
                case 'Decimal':
                case 'Whole.Duration':
                case 'Whole.None': {
                    result = new NumberCondition().isValid(this._record.getValue(attributeName) as number | null, condition);
                    break;
                }
                case 'DateAndTime.DateAndTime':
                case 'DateAndTime.DateOnly': {
                    result = new DateCondition().isValid(this._record.getValue(attributeName) as string | null, condition);
                    break;
                }
                case 'OptionSet':
                case 'TwoOptions': {
                    result = new OptionSetCondition().isValid({ value: this._record.getValue(attributeName) as number, formattedValue: this._record.getFormattedValue(attributeName) }, condition);
                    break;
                }
                case 'MultiSelectPicklist': {
                    result = new MultiSelectOptionSetCondition().isValid({ value: this._record.getValue(attributeName) as string, formattedValue: this._record.getFormattedValue(attributeName) }, condition);
                    break;
                }
                case 'Lookup.Customer':
                case 'Lookup.Owner':
                case 'Lookup.Regarding':
                case 'Lookup.Simple': {
                    result = new LookupCondition().isValid({ value: this._record.getValue(attributeName) as ComponentFramework.EntityReference, formattedValue: this._record.getFormattedValue(attributeName) }, condition);
                }
            }
            if (type === FilterType.And.Value) {
                if (!result) {
                    return false;
                }
            }
            else if (result) {
                return true;
            }
        }
        return result;
    }

    private _conditionDecorator(condition: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression) {
        const _cond = { ...condition };
        let column = this._dataProvider.getColumns().find(x => x.name === condition.attributeName);
        if (!column) {
            _cond.attributeName = condition.attributeName.slice(0, -4);
        }
        switch (condition.conditionOperator) {
            case Operators.BeginsWith.Value:
            case Operators.DoesNotBeginWith.Value: {
                _cond.value = condition.value.slice(0, -1);
                break;
            }
            case Operators.EndsWith.Value:
            case Operators.DoesNotEndWith.Value: {
                _cond.value = condition.value.slice(1);
                break;
            }
            case Operators.Like.Value:
            case Operators.NotLike.Value: {
                _cond.value = condition.value.slice(1, -1);
                break;
            }
        }
        return _cond;
    }
}
